/** Canonical production origin. Keep in sync with public/index.html and robots.txt. */
export const CANONICAL_ORIGIN = 'https://flowdo.biz';

export function normalizePath(pathname) {
  if (!pathname) return '/';
  let path = String(pathname).split('?')[0];
  if (!path.startsWith('/')) path = `/${path}`;
  if (path.length > 1 && path.endsWith('/')) path = path.slice(0, -1);
  return path || '/';
}

/** Default document title (keep in sync with public/index.html). */
export const DEFAULT_TITLE = 'flowdo | Modular business software for SMBs';

/** Default meta description (keep in sync with public/index.html). */
export const DEFAULT_DESCRIPTION =
  'flowdo is modular business software for SMBs. Start free with Tasks, Documents, Snap Bill, Projects, Vault, and Forum. No credit card required.';

export const OG_IMAGE_PATH = '/og-image.png';
export const THEME_COLOR = '#c42126';

export function isPrerender() {
  return typeof window !== 'undefined' && window.__PRERENDER__ === true;
}

export function isIndexableHostname(hostname) {
  if (isPrerender()) return true;
  const host = String(hostname || '').toLowerCase();
  return host === 'flowdo.biz' || host === 'www.flowdo.biz';
}

export function canonicalUrl(pathname = '/') {
  return `${CANONICAL_ORIGIN}${normalizePath(pathname)}`;
}

export function ogImageUrl() {
  return `${CANONICAL_ORIGIN}${OG_IMAGE_PATH}`;
}
